angular.module('unica_invitation_list.invitation_list_controllers')

.controller('InvitationListCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	InvitationListCreateService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventStages( $stateParams.event_id );

	$rootScope.invitationListData = {
		event_id: $stateParams.event_id
	};

	$scope.saveInvitationList = function() {
		$scope.showLoader();

		var invitationListData = angular.copy($rootScope.invitationListData);
		invitationListData = $scope.parseInvitationListToTimestamp(invitationListData);

		InvitationListCreateService
			.create( invitationListData )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Tipologia Lista aggiunta con successo!', '');
					$state.go('app.invitation_list.list', { event_id: $stateParams.event_id });
				} else {
					$rootScope.manageError(data);
				}
			});

	};


});